import { MasterClassStudioQuery } from '@/generated/graphql'
import StudioCard from '../StudioCard'

export type StudioLesson = NonNullable<
  NonNullable<MasterClassStudioQuery['streams']>['items']
>[number]

type Props = {
  lessons: StudioLesson[]
}

const StudioGrid = ({ lessons }: Props) => {
  return (
    <section>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {lessons.map(lesson => (
          <StudioCard key={lesson.id} lesson={lesson} />
        ))}
      </div>
    </section>
  )
}

export default StudioGrid
